import { pendingDepositTabSyncedActions } from './balances/pendingDeposits';
import { sendReduxActionToOtherTabs } from './crossTabsCommunication';
import { ReduxState, ReduxActions } from './storeCore';

type Middleware = (
  store: ReduxState
) => (
  next: (action: ReduxActions) => ReduxState
) => (action: ReduxActions) => void;

/**
 * Redux Middleware which runs on each action dispatch
 * Use only when it's really neccessary (eg. cross tab sync, logging)
 */
export const customDispatchMiddleware: Middleware =
  _store => next => action => {
    if (
      // Sync for User
      action.type === 'CHANGE_USER' ||
      // action.type === 'UPDATE_USER_TIER_STATUS' ||
      // Sync for Wallet
      action.type === 'CHANGE_WALLET' ||
      action.type === 'SET_PERSONAL_WALLET_SECRET' ||
      action.type === 'REMOVE_WALLET' ||
      pendingDepositTabSyncedActions.find(pending => pending === action.type)
      // Sync for Pending or Failed liquidity transactions
      // crossTabSyncedActions.find(crossAction => crossAction === action.type)
    ) {
      // TODO: circular dependency: resolve
      sendReduxActionToOtherTabs(action);
    }

    const result = next(action);
    // console.log('next state', store.getState())
    return result;
  };
